var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95443 31.0459 0.00012207 20.0002 0.00012207C8.95449 0.00012207 0.000183105 8.95443 0.000183105 20.0001C0.000183105 31.0458 8.95449 40.0001 20.0002 40.0001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.181 16.3428L20.8221 18.6041L23.4796 17.7424L21.836 20.0018L23.4768 22.263L20.8202 21.398L19.1767 23.6574L19.1784 20.8636L16.5217 19.9986L19.1793 19.1368L19.181 16.3428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7027 25.6523C11.5811 25.6523 9.05048 23.1217 9.05048 20.0001C9.05048 16.8786 11.5811 14.348 14.7027 14.348C15.676 14.348 16.5917 14.5941 17.3913 15.0273C16.137 13.8006 14.4216 13.0436 12.5288 13.0436C8.68673 13.0436 5.57228 16.1581 5.57228 20.0001C5.57228 23.842 8.68681 26.9565 12.5288 26.9565C14.4217 26.9565 16.137 26.1994 17.3913 24.9728C16.5917 25.4062 15.676 25.6523 14.7027 25.6523V25.6523Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.67bedd5c134286fc9bf2e9472194036b.svg";
export { ForwardRef as ReactComponent };